import { Group } from "@mantine/core"
import { SuperAdminVenueAreaTabs } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaTabs"
import { EditSuperAdminVenueAreaAction } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaActions"
import { useAppState } from "src/state"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { SuperAdminVenueAreaView } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaView"

export const SuperAdminVenueAreaOverlay = () => {

    const { currentItem } = useAppState(state => state.areas)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminVenueAreaAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminVenueAreaTabs overlay/>
            <SuperAdminVenueAreaView/>
        </DrawerPageLayout>
    )

}